export type Club = {
    new: boolean
    name: string
    type: string
    // tier: 1 | 2 | 3
    tier: string // see scripts/genClubs.ts:34
    desc: string
    day: string
    freq: string
    time: string
    room: string
    prez: string
    advisor: string
    email: string
    coadvisor?: string
    coemail?: string
}

const clubs: {timestamp: string, data: {[key: string]: Club}} = {
    "timestamp": "2026-09-14T05:00:09.806Z",
    "data": {
        "12592": {
            "new": false,
            "name": "Business Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "The Gunn Business Club is a community for students who are interested the world of commerce, or anyone who simply wants to learn more about business sectors like Entrepreneurship, Finance, Marketing, Business Administration, or Hospitality & Tourism. Our mission is to bridge the gap between classroom learning and the real world by offering hands-on experiences that bring business concepts to life. Members gain practical skills through workshops, guest speakers, and other hands-on activities that explore real-world business challenges. No experience is required, just curiosity and an interest in learning something new!",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-215",
            "prez": "Isaiah Dai",
            "advisor": "Khoa Dao",
            "email": "kdao@pausd.org"
        },
        "12624": {
            "new": true,
            "name": "Young Life Club",
            "type": "Culture, Religion, and Language",
            "tier": "Special Interest",
            "desc": "Gunn Young Life club is a faith based club where we get together during lunch, to play games, and talk about life and faith. All are welcome to check it out regardless of beliefs! We would love to see you there for a great time!",
            "day": "Wednesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "G-3",
            "prez": "Celine Fidanboylu",
            "advisor": "Kirsten Tasker",
            "email": "ktasker@pausd.org"
        },
        "12998": {
            "new": true,
            "name": "Anime and Manga Club",
            "type": "Social",
            "tier": "Financial",
            "desc": "Anime and Manga club is for everyone who’s passionate or interested in watching anime or reading manga. We will occasionally watch anime episodes, share news, run events, enjoy food, and hang out with friends, all while learning about not just anime and manga but about each other too.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-108",
            "prez": "Victoria Blanchet",
            "advisor": "Terence Kitada",
            "email": "tkitada@pausd.org"
        },
        "14957": {
            "new": false,
            "name": "Architecture Club",
            "type": "Visual Arts and Media",
            "tier": "Financial",
            "desc": "Learn about architecture throughout history, the future of architecture, different cultures styles of architecture, hands on activities in design, as well as learn about the industry with multiple guest speakers.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-211",
            "prez": "Kai Messerian",
            "advisor": "Ms. Richards",
            "email": "crichards@pausd.org",
            "coadvisor": "Mr. Gill",
            "coemail": "dgill@pausd.org"
        },
        "16239": {
            "new": false,
            "name": "Aeronautics",
            "type": "STEM",
            "tier": "Financial",
            "desc": "The Gunn Aeronautics Club is a club meant to foster the exploration of science, technology, engineering, and mathematics (STEM), through the lens of flight. We cultivate the creativity required for thriving in this field by diving into hands-on engineering challenges and problems with regards to aeronautics. Some of these projects might include a quad copter FPV drone or an autonomous RC plane. Through these projects, members will learn about physics, math, electrical design, and computer aided design (CAD). To supplement the hands-on activities we will have, we will also have discussions and presentations on a plethora of aeronautics related topics. These will include but are not limited to aerospace innovations, aerospace design, the math and physics that allows flight, and how to design aircraft. If you enjoy aircraft, space, RC vehicles, or STEM, then join the Aeronautics Club.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-212",
            "prez": "Henry Dominik",
            "advisor": "David Deggeller",
            "email": "ddeggeller@pausd.org"
        },
        "17650": {
            "new": false,
            "name": "American Heart Association Club",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "We started the American Heart Association (AHA) Club to raise awareness about heart-related diseases and promote heart health among students and our community. Heart disease is the leading cause of death worldwide, with the highest mortality rate in the US, and many people are unaware of the lifestyle risks for cardiovascular diseases (CVD) or how to respond in an emergency. Through events, our club hopes to help our members understand the importance of heart health, discuss prevalent CVDs, and contribute to our community. AHA Club meetings and activities will combine service activities like making bracelets for children coping with CVDs at Lucile Packard Children's Hospital at Stanford with well-being and scientific learning. Members of our club will learn the basics of cardiovascular health and research, including heart anatomy and physiology, and how lifestyle choices such as nutrition, physical activity, sleep, and stress affect heart health. Members can also participate in case studies and explore diagnostic treatments, as well as experience guest speakers who will include healthcare professionals. One of our main goals is to organize a CPR awareness and certification fundraiser with certified instructors, where students can learn hands-on CPR and what to do in real-life emergencies. The goal of this event is to help students feel prepared and to show that basic CPR skills are something anyone can learn. Through events like this, members will build teamwork skills while making a meaningful impact on our school community.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-109",
            "prez": "Gia Vakklaganti",
            "advisor": "Danielle Whichard",
            "email": "dwhichard@pausd.org"
        },
        "17847": {
            "new": false,
            "name": "Financial Literacy Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "The Gunn Financial Literacy Club seeks to educate students on important topics in personal finance such as saving, budgeting, borrowing, and investing. This will include presentations, fun videos, interactive activities like Kahoot, and guest speakers. We hope to equip students with real-world financial skills so that we could establish good habits, make informed decisions, and create lifelong financial freedom.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-205",
            "prez": "Ellie Hu",
            "advisor": "Gopi Tantod",
            "email": "gtantod@pausd.org"
        },
        "18538": {
            "new": false,
            "name": "Film Club",
            "type": "Visual Arts and Media",
            "tier": "Financial",
            "desc": "A space to watch and create movies, welcoming to all whether you’re a cinema enthusiast or a casual watcher. We will watch, analyze, and produce our own films this year, and host movie nights and festivals!",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "L-6",
            "prez": "Johnny Na",
            "advisor": "Edward Corpuz",
            "email": "ecorpuz@pausd.org"
        },
        "19916": {
            "new": false,
            "name": "Chinese Culture Club",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "Chinese Culture Club aims to educate Gunn community members about Chinese culture and language. This revolves around a central purpose: to maintain an international cultural group of Gunn’s diverse student body. The club will do so by meeting weekly to discuss various topics surrounding historical and present Chinese culture. Some topics covered during our meetings include festivals, food, modern ideas, traditions in different regions, and celebrations.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "H-4",
            "prez": "Vin Bhat",
            "advisor": "Yanan Vrudny",
            "email": "yvrudny@pausd.org"
        },
        "20009": {
            "new": false,
            "name": "Cubing Club",
            "type": "Recreation",
            "tier": "Financial",
            "desc": "What’s the first word you think of when you think of people who can solve Rubik's cubes? If you said “cool”, then YOU are who we are looking for at the Cubing Club! You don’t even need to have touched a cube before! All we need is four lunches to teach you how to solve a 3x3. And if you have experience, we teach you how to solve all sorts of other cubes too! We only promise two things: 1) you will learn something, and 2) you will find friends. So come to K-10 on Friday to have some cubing fun!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-10",
            "prez": "Matt Mao",
            "advisor": "Clare Gleeson",
            "email": "cgleeson@pausd.org"
        },
        "20485": {
            "new": false,
            "name": "Biotech Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "The Biotech Club is dedicated to teaching students about various exciting applications of biotechnology, such as CRISPR, nanotechnology, stem cells, and their impact on modern medicine! Special events that we plan to do this school year include hosting guest speakers from biotechnology companies, playing Kahoots, and organizing a fundraiser.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "L-2",
            "prez": "Ella Tal",
            "advisor": "Angela Merchant",
            "email": "amerchant@pausd.org"
        },
        "20588": {
            "new": false,
            "name": "Start-Up Club",
            "type": "Discussion",
            "tier": "Financial",
            "desc": "The Start-Up Club empowers students to explore entrepreneurship by learning how to create, pitch, and develop start-up ideas. Members will engage in workshops, case studies, guest speaker events, and collaborative brainstorming sessions. The club’s mission is to foster creativity, critical thinking, and leadership while preparing students to turn innovative ideas into actionable business plans.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-1",
            "prez": "William Jia",
            "advisor": "Amy Bradshaw",
            "email": "abradshaw@pausd.org"
        },
        "20692": {
            "new": false,
            "name": "Rhythm Game Club",
            "type": "Music and Performing Arts",
            "tier": "Financial",
            "desc": "Play rhythm games like Project Sekai and Phigros together! Comparing our scores, challenging each other, and working as a team to help everyone unlock higher-ranking songs. Join in the fun and level up your rhythm skills!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-6",
            "prez": "Shiqi Dai",
            "advisor": "Alexis Lee",
            "email": "aletner@pausd.org"
        },
        "20761": {
            "new": false,
            "name": "Food Science Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Our goal is to educate Gunn students about the many aspects of food science and provide presentations, samples, and experiments for them to apply their knowledge. These experiments will explore the science behind making certain foods on a molecular level, technology behind food production and preservation, and how food science directly connects back to our community and how it fights food insecurity. Specific experiments include explaining fermentation through yeast experiments, building DIY solar ovens, vitamin C iodine titration, DIY ice cream, and much more.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-110",
            "prez": "Athena Gao",
            "advisor": "Jasmine Cadenas",
            "email": "jcadenas@pausd.org"
        },
        "21111": {
            "new": false,
            "name": "ROCK Club",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "ROCK, Reach Out Care Know is a mental health awareness club. We provide community, lectures, and fun social events geared toward creating a better culture around mental health.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-114",
            "prez": "Melody Song",
            "advisor": "Paul Dunlap",
            "email": "pdunlap@pausd.org"
        },
        "21226": {
            "new": false,
            "name": "Thespian Club",
            "type": "Music and Performing Arts",
            "tier": "Financial",
            "desc": "A place where we play theatre games and a great outlet to get involved in Gunn's theatre community!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "Little Theatre (S-1)",
            "prez": "Mina Van Roy",
            "advisor": "Kristen Lo",
            "email": "klo@pausd.org"
        },
        "22965": {
            "new": false,
            "name": "Japanese Culture Club",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "The Japanese Culture Club (JCC) introduces students to the many facets of Japanese culture through hands-on activities, food, presentations, and videos, including occasional film screenings (e.g. anime). Members explore both traditional and modern-day trends of Japan in a fun, welcoming environment. No prior knowledge of Japanese needed!",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-108",
            "prez": "Erin Tsutsui",
            "advisor": "Terence Kitada",
            "email": "tkitada@pausd.org"
        },
        "23091": {
            "new": true,
            "name": "The Water Action Project",
            "type": "Discussion",
            "tier": "Special Interest",
            "desc": "The Water Action Project is a club that gives people a platform to express their perspectives through art and writing, and organizes realistic community action projects. Our mission is to inspire and engage students to spread awareness about the marine environment and the global water crisis through artistic and written expression. Topics we wish to explore include global water access and water equity, ocean ecosystems, plastic pollution, droughts, and the overall effect of climate change on the ocean and other water systems. No experience or prior knowledge necessary, feel free to stop by!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-3",
            "prez": "Shrishti Sinha",
            "advisor": "Benjamin Beresford",
            "email": "bberesford@pausd.org"
        },
        "23208": {
            "new": false,
            "name": "HOSA – Future Health Professionals",
            "type": "Competition (only for Financial Clubs)",
            "tier": "Financial",
            "desc": "HOSA – Future Health Professionals is a chapter club intended for students who are interested in exploring careers in healthcare and learning more about medicine, nursing, public health, biomedical research, among other health professions. Throughout the year, we host guest speakers, participate and travel for HOSA competitive events, volunteer in community service projects, and organize activities such as blood drives and healthcare outreach. Members also have opportunities to develop leadership skills, meet students with similar interests, and learn more about different healthcare careers.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "L-2",
            "prez": "Carolyn Xiao",
            "advisor": "Angela Merchant",
            "email": "amerchant@pausd.org",
            "coadvisor": "Micah Wynn",
            "coemail": "mwynn@pausd.org"
        },
        "23897": {
            "new": false,
            "name": "Autonomous Robotics Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "Our club promotes hands-on robotics education, especially focusing on autonomous robotics. We collaborate as a club to construct autonomous robotics and organize other community outreach events related to robotics education. Next year, we plan to focus on education aspects, teaching new members about how to build and program robots. We are currently working on constructing a fully functional autonomous maze following robot.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-102",
            "prez": "Genevieve Forte",
            "advisor": "Kristen Owen",
            "email": "kowen@pausd.org"
        },
        "24319": {
            "new": false,
            "name": "Youth Community Service",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "Youth Community Service (YCS) is a community service club that works with the community organization, YCS, to try and improve our community. Some of the events we put on are Service Day, Service Fair, Service Trip, and an Open Mic. We also regularly update club members on different community service opportunities as we are notified about them.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-115",
            "prez": "McKenna Chang",
            "advisor": "Diane Ichikawa",
            "email": "dichikawa@pausd.org"
        },
        "25945": {
            "new": false,
            "name": "Newcomer Buddy Club",
            "type": "Service and Wellbeing",
            "tier": "Special Interest",
            "desc": "Are you a newcomer or someone who wants to support their peers at Gunn? Whether you're currently attending Gunn, joined mid-year from within the state, out of state, or another country, the Newcomer Buddy Program is here to help you! We pair students with a Buddy, a 10th, 11th, or 12th-grade student who can offer guidance, and support. Our mission is to provide a welcoming and structured environment for both newcomers and their buddies. We facilitate regular check-ins and meetings, helping everyone build connections, navigate the school environment, and foster a strong sense of belonging. We also work closely with the Counseling Department and Administration Team to ensure students receive the support they need. This year we are also working with the ELL teachers to bring this program to ELL students. Through our efforts, we aim to create an inclusive and supportive community for everyone at Gunn. We were also awarded the PAUSD PTSA Service Award in the spring of 2025 for our contributions to the community. If you would like to become part of this wonderful program, please sign up to be a member, and we look forward to seeing you soon!",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-6",
            "prez": "Abigail Dusane",
            "advisor": "Alexis Lee",
            "email": "aletner@pausd.org"
        },
        "26186": {
            "new": true,
            "name": "Science Research Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "Our club gives a collaborative learning space for those competing in science fair or pursuing any type of independent scientific research.  We aim to help new students get started with research basics, as well as providing a community for more experienced students.  Our main focus during the first semester will be covering the basics of experimental design and research development; during the second semester, we will discuss writing lab reports and research papers, as well as providing assistance for those planning on competing in local fairs.  Students can segue into their own individual projects, where we provide opportunities for peer reviews and competition preparation.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-7",
            "prez": "Sophie Tong",
            "advisor": "Elana Zizmor",
            "email": "ezizmor@pausd.org"
        },
        "26336": {
            "new": false,
            "name": "Latinos Unidos",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "Latinos Unidos is a club that supports Hispanic/Latino students and gives them a place to feel welcome. We share and learn about Hispanic/Latino culture through fun activities and events. Everyone is welcome to join, make friends, and learn together.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "G-7",
            "prez": "Ricardo Soria",
            "advisor": "Daissy Tabares",
            "email": "dtabares@pausd.org",
            "coadvisor": "Rossana Castillo",
            "coemail": "Rcastillo@pausd.org"
        },
        "26859": {
            "new": false,
            "name": "A Capella Club",
            "type": "Music and Performing Arts",
            "tier": "Financial",
            "desc": "Rehearsing music arrangements in A capella style, creating community open to all levels/interests of singing, hoping to create a place where singers can collaborate.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "S-121",
            "prez": "Paxton Manning",
            "advisor": "Angelina Fitzhugh",
            "email": "afitzhugh@pausd.org"
        },
        "28117": {
            "new": false,
            "name": "Climbing Club",
            "type": "Sports",
            "tier": "Special Interest",
            "desc": "Climbing club is a place that gathers the climbers of Gunn into a joint space. We welcome every skill level and hope to educate on technique and everything climbing!",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "M-4",
            "prez": "Paxton Manning",
            "advisor": "Anita Su",
            "email": "asu@pausd.org"
        },
        "29045": {
            "new": false,
            "name": "Machine Learning Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "Learn more about machine learning via current events, short lectures, guest speakers (hopefully), etc.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-203",
            "prez": "Owen Cheng",
            "advisor": "Michael Bautista",
            "email": "mbautista@pausd.org"
        },
        "29742": {
            "new": true,
            "name": "Cultural Connection Club",
            "type": "Culture, Religion, and Language",
            "tier": "Special Interest",
            "desc": "The Cultural Connection Club creates a welcoming space for students to explore cultural identity. Their own and others. We’re especially here for students who feel disconnected from their heritage, offering a low pressure way for people to learn, question, and reconnect. Through a member led presentation, shared food and celebrations of holidays. We build a community where every culture is something to be curious about, not just observed.",
            "day": "Thursday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "N-208",
            "prez": "Khushi Kumar",
            "advisor": "Silverbush",
            "email": "jsilverbush@pausd.org"
        },
        "29922": {
            "new": false,
            "name": "Model United Nations",
            "type": "Competition (only for Clubs)",
            "tier": "Financial",
            "desc": "The Gunn Model United Nations club is a political/international affairs debate club where members have the opportunity to simulate the United Nations through different committees and have opportunities to discuss global and historical events through different committee styles like GA, specialized, and crisis. The purpose of our club is to foster diplomatic debate across different global events and give delegates the opportunity to practice their leadership, research, and debate skills. Within meetings, we discuss conference procedures, current world updates, and travel logistics. Our club also has the opportunity to travel to national MUN conferences and practice debate with delegates from a regional to international level.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-8",
            "prez": "Alina Fleischmann",
            "advisor": "Jeff Patrick",
            "email": "jpatrick@pausd.org"
        },
        "29942": {
            "new": false,
            "name": "Psychology Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "A super fun and interactive club talking all about the mind and it's behavior with discussions about social experiments and mental conditions, Room C2 every Friday at lunch!!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-2",
            "prez": "Emilie Matthey",
            "advisor": "Warren Collier",
            "email": "wcollier@pausd.og"
        },
        "30128": {
            "new": false,
            "name": "Neuroscience Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "The Gunn Neuroscience Club seeks to educate students on important topics in neuroscience and introduce them to opportunities outside of school, in the field. This will include presentations, fun videos, interactive activities like Kahoot, guest speakers, and occasional field trips to labs. Ultimately, we hope to spread an appreciation for neuroscience, and further fuel the attendees’ interest in the field!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-208",
            "prez": "Yaya Li",
            "advisor": "Jacquelyn Silverbush",
            "email": "jsilverbush@pausd.org"
        },
        "30444": {
            "new": false,
            "name": "Pickleball Club",
            "type": "Sports",
            "tier": "Special Interest",
            "desc": "If you're dinking of finding a fun club to be a part of, look no further than PICKLEBALL SPECIAL INTEREST CLUB! Gunn Pickleball is dedicated to fostering a positive and inclusive atmosphere within the Gunn High School community. In a stressful academic environment, we believe that pickleball—a lightweight, fun, and community-driven sport—provides the perfect outlet for students. Our goal is to offer a space where everyone can unwind, whether through rallying with friends, playing competitive games, or just enjoying the game in a relaxed manner.  We emphasize the importance of building connections and friendships within the special interest group, creating a supportive network for all members. Above all, we prioritize having fun. Whether you're a seasoned player or just looking to try something new, our special interest group is a place to enjoy the sport without pressure. We also recognize the need to balance academic responsibilities with physical activity. Our special interest group encourages an active lifestyle that complements school life, helping students manage stress and stay active. Make sure to show up and have fun!",
            "day": "Friday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "Tennis Courts",
            "prez": "Ezra Rosenberg",
            "advisor": "Mark Weisman",
            "email": "mweisman@pausd.org"
        },
        "32414": {
            "new": false,
            "name": "Board Game Club",
            "type": "Social",
            "tier": "Special Interest",
            "desc": "Love board games? Come join Board Game Club! Whether you're into strategy games, party games, card games, or just looking for a fun way to hang out with friends, there's something for everyone. Come play, learn new games, meet new people, and have a great time!",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "PE classroom",
            "prez": "Sam Bergmann",
            "advisor": "Amy Anderson",
            "email": "amanderson@pausd.org",
            "coadvisor": "Paul Maderos",
            "coemail": "pmedeiros@pausd.org"
        },
        "32601": {
            "new": false,
            "name": "Peer Mentorship Club",
            "type": "Service and Wellbeing",
            "tier": "Special Interest",
            "desc": "The Peer Mentorship Club focuses on improving the relationship between underclassmen and upperclassmen and provides advice on school-related topics, with each meeting featuring upperclassmen mentors sharing notable experiences from their time at Gunn or offering advice on how to thrive in certain classes. Members swap advice on course selection, study approaches, extracurricular activities, and long-term planning, giving underclassmen clearer insight into what different paths can look like and how to pursue them effectively. By hearing real examples of what upperclassmen tried and what they would do differently, underclassmen can approach school with more clarity, helping ease the pressure that often comes from uncertainty and comparison.",
            "day": "Wednesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "C-7",
            "prez": "Connor Ding",
            "advisor": "Max Zipperstein",
            "email": "mzipperstein@pausd.org"
        },
        "34635": {
            "new": true,
            "name": "Bike Repair Club",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "The Gunn Bike Repair Club will be focused on repairing bikes for Gunn students and teachers.  It will also provide discount priced bikes for people who need them.  Our goal is to become a bike repair and purchase service the Gunn community can trust that is also affordable, easy to contact, easy to access, and easy to interact with.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "After School",
            "room": "In the back of L-8",
            "prez": "Willy Piryazev",
            "advisor": "Tomas Grim",
            "email": "tgrim@pausd.org"
        },
        "35985": {
            "new": false,
            "name": "Best Buddies",
            "type": "Social",
            "tier": "Special Interest",
            "desc": "Best Buddies is an inclusive community that fosters connections and friendships between FUTURES/SpEd students and their compassionate peers. This unique club creates a safe and welcoming space where understanding, acceptance, and genuine friendships flourish. The club's primary mission is to promote empathy, awareness, and inclusivity within the school community. By bridging the gap between students with special needs and their peers, Best Buddies aims to break down stereotypes, reduce stigmas, and create a supportive environment where everyone feels valued and understood.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "F-2",
            "prez": "Vin Bhat",
            "advisor": "C.Montserrat Arellanes",
            "email": "carellanes@pausd.org"
        },
        "36632": {
            "new": true,
            "name": "First Layers",
            "type": "STEM",
            "tier": "Financial",
            "desc": "First Layers is a student club for designing and 3D printing your own models. We meet weekly to learn CAD in Onshape, work on projects, and explore everything that goes into 3D printing. Onshape is free and runs in a browser. Project ideas include phone stands, small miniatures, and custom models of your own design. If you've never touched a 3D printer, that's fine. Most of us started that way. Already a pro? Show us what you've got. Come join the club and turn your ideas into real objects you can hold.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "F-4",
            "prez": "Agustya Sinha",
            "advisor": "Tomas Grim",
            "email": "tgrim@pausd.org"
        },
        "37185": {
            "new": false,
            "name": "Neurodiversity Alliance",
            "type": "Social",
            "tier": "Special Interest",
            "desc": "In Neurodiversity Alliance club we hope to cover and raise awareness different neurodiversity (such as autism, ADHD, ect.). Through weekly meetings and guest speakers we want to cover what these conditions look like both neuroligically and behaviorally and how life would look like managing one or more of these conditions. We hope to create a safe space as well and raise awareness about accommodations and self advocacy.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-10",
            "prez": "Alina Fleischmann",
            "advisor": "Clare Gleeson",
            "email": "cgleeson@pausd.org"
        },
        "37194": {
            "new": false,
            "name": "Girl Up",
            "type": "Humanities",
            "tier": "Special Interest",
            "desc": "Girl Up is founded by the UN to advocate for the empowerment of young girls, teach and spread awareness on women’s rights, and encourage you to make a change in our community. We cover topics like climate change, sports, mental health, gender-based violence, activism, history, and more, and have an open community where people can make friends while sharing their ideas.",
            "day": "Friday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "N-104",
            "prez": "Megan Moeljo",
            "advisor": "Marjorie Paronable",
            "email": "mparonable@pausd.org"
        },
        "38073": {
            "new": false,
            "name": "Amnesty International",
            "type": "Discussion",
            "tier": "Special Interest",
            "desc": "As an official chapter of Amnesty International, a worldwide movement of more than 10 million people who campaign for human rights, this club raises awareness of global injustices and current events through discussions, petitions, and advocacy. Amnesty International branches beyond the national scale and works with international governments, judicial systems, and nonprofits, finding purpose in enacting real, tangible policy change. Our club aims to increase accessibility to otherwise intimidating topics like human rights, legislation, government structures, and public policy, encouraging youth engagement with them. We strive to give Gunn students the power, resources, and knowledge to mobilize their own action in justice.   If you are interested in social justice, political science, law, current events, public policy, philosophy, environmental science, research, media, debate, or simply want to create positive change, Amnesty International is the club for you!",
            "day": "Friday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "C-8",
            "prez": "Sarah Grupenhoff",
            "advisor": "Tara Firenzi",
            "email": "tfirenzi@pausd.org"
        },
        "38304": {
            "new": false,
            "name": "Hiking Club",
            "type": "Recreation",
            "tier": "Financial",
            "desc": "Our purpose is to educate gunn students about nature and how to preserve public lands. We will also provide opportunities to get out into nature for mental health and overall enjoyment as well as community service. Well have weekly meetings where students will learn about lands in the national park service aswell as lands all over the world, well talk about things like backpacking, camping, hiking in all facets. Our overall goal is to connect students with others who enjoy the same thing while also teaching them about nature and providing opportunities to get out there and expirience it.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-5",
            "prez": "Tim Landt",
            "advisor": "Ning Xu",
            "email": "nxu@pausd.org"
        },
        "38522": {
            "new": false,
            "name": "Style Swap",
            "type": "Recreation",
            "tier": "Special Interest",
            "desc": "Come to discuss and learn the impacts of fast fashion, swap clothes with your peers, participate in fun games, and make our community sustainably fashionable!",
            "day": "Wednesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "N-207",
            "prez": "Vaani Saxena",
            "advisor": "Florina Limburg",
            "email": "flimburg@pausd.org"
        },
        "38776": {
            "new": false,
            "name": "History Club",
            "type": "Humanities",
            "tier": "Special Interest",
            "desc": "Welcome to Gunn History Club! We are a student-run space dedicated to exploring history and the broader humanities, from ancient civilizations and US History to interdisciplinary connections in STEM, music, and beyond. Through fun activities, presentations, and movies, members examine the ideas and events that continue to shape our world, using history as a lens to better understand the present. Come join us!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-1",
            "prez": "Ananya Iyer",
            "advisor": "Christopher Johnson",
            "email": "cjohnson@pausd.org"
        },
        "38918": {
            "new": false,
            "name": "Gender Sexuality Alliance (GSA)",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "A brave space providing advocacy and connection for the LGBTQ+ community at Gunn and beyond. We welcome all LGBTQ+ students and allies. We hold discussions and invite guest speakers to talk about what we can do as a community to support those around us, as well as enjoy fun recreational activities.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "H-2",
            "prez": "Evan Little",
            "advisor": "Claudia Schroeppel",
            "email": "cschroeppel@pausd.org"
        },
        "39470": {
            "new": true,
            "name": "The Mouse Control Improvement and Gaming Peripheral Discussion Committee",
            "type": "Social",
            "tier": "Special Interest",
            "desc": "A club where likeminded who seek to improve mousecontrol and to discuss about gaming peripherals gather.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-103",
            "prez": "Nathan Xie",
            "advisor": "Miranda Long",
            "email": "mlong@pausd.org"
        },
        "41078": {
            "new": false,
            "name": "Vietnamese Culture Club",
            "type": "Culture, Religion, and Language",
            "tier": "Special Interest",
            "desc": "The Vietnamese Culture Club (VCC) is dedicated to the exploration, education, and understanding of the Vietnamese customs, traditions, and language. Through music, food, and art, our goal is to have every member develop a greater appreciation for Vietnamese culture. We welcome all students interested to partake in our wide range of inclusive social activities and cultural celebrations.",
            "day": "Thursday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "M-5",
            "prez": "Ella Nguyen",
            "advisor": "Tim Young",
            "email": "tyoung@pausd.org",
            "coadvisor": "Anita Su",
            "coemail": "asu@pausd.org"
        },
        "42161": {
            "new": true,
            "name": "Turkish Club",
            "type": "Culture, Religion, and Language",
            "tier": "Special Interest",
            "desc": "Club where we will learn about the Turkish language, history, culture, and cuisine.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-104",
            "prez": "Burak Sakalsiz",
            "advisor": "Owen, Kristen",
            "email": "kowen@pausd.org"
        },
        "42822": {
            "new": false,
            "name": "Medicine without Borders",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "In the club, Medicine without Borders, we aim to learn, inspire, and take action in the pursuit of helping underprivileged communities around the world. It aims to transform volunteering and community engagement, emphasizing listening, analyzing root causes, and educational exchange. The organization is dedicated to raising awareness, fundraising, and mobilizing students for service.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-3",
            "prez": "Yuexuan Liu",
            "advisor": "Benjamin Beresford",
            "email": "bberesford@pausd.org"
        },
        "43135": {
            "new": false,
            "name": "Science Bowl",
            "type": "STEM",
            "tier": "Financial",
            "desc": "We are Gunn Science Bowl, a school club dedicated to spreading curiosity for STEM and catalyzing exploration. Annually, we compete in the National Science Bowl, a nationwide competition hosted by the U.S. Department of Energy. We seek to create a community of intelligent, driven individuals in the pursuit of knowledge, and while we strive for excellence, we also promote an environment of teamwork, ingenuity, and creativity.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-3",
            "prez": "Olivia Kim",
            "advisor": "Heather Mellows",
            "email": "hmellows@pausd.org"
        },
        "43151": {
            "new": false,
            "name": "Creative Writing Club",
            "type": "Visual Arts and Media",
            "tier": "Special Interest",
            "desc": "A fun place to write and share creative ideas with friends. We provide weekly writing prompts and discussion topics to challenge writers and encourage creativity. We also work on optional long-term projects where everyone collaborates on a single story. We provide plenty of opportunities to showcase writing through our annual short story contest or during club hours. The club is also available for people who just want a chill space to write stories or brainstorm.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "P-115",
            "prez": "Ellie Cardozo",
            "advisor": "Melanie Elmont",
            "email": "melmont@pausd.org"
        },
        "43418": {
            "new": false,
            "name": "Physics Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "The Gunn Physics Club will meet weekly to host interactive presentations and hands-on experiments on content both in and beyond physics classes. We explore physics phenomenon with conceptual problems and live demonstrations, and host in-club events such as Fermis and mini engineering physics-related challenges. We will also host study sessions for AP Physics exams and physics competitions (such as the F=ma & Physics Bowl). All are welcome; no prior experience required!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-9",
            "prez": "Chloe Wu",
            "advisor": "Shilpan Sheth",
            "email": "ssheth@pausd.org"
        },
        "43441": {
            "new": false,
            "name": "National Art Honor Society",
            "type": "Visual Arts and Media",
            "tier": "Financial",
            "desc": "Join National Art Honor Society in M-4 to learn about all things visual art, creativity, and art appreciation! Participate in fun art projects, hands-on activities, art games and challenges, and become a member of the National Art Honor Society. No previous experience necessary, just creativity and an interest in art! Snacks/candy provided to fuel your creative visions!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "M-4",
            "prez": "Claire Sim",
            "advisor": "Anita Su",
            "email": "asu@pausd.org"
        },
        "43694": {
            "new": true,
            "name": "Applied AI Engineering Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "We build AI/ML projects, from creating better study tools to developing solutions for real-world problems. As we grow, we plan to expand into helping small businesses or other communities integrate ML and other software infrastructure into their system.  Members will learn how to become ML/AI engineers by working through problems from Deep-ML.com and applying those concepts to real projects: training models, integrating them into web apps, and deploying applications that people can actually use.  Our meetings are hands-on and fun, with no prior experience required. Just bring a laptop and something you want to build!",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-1",
            "prez": "Michael Ma",
            "advisor": "Ariane Tuomy",
            "email": "atuomy@pausd.org"
        },
        "44391": {
            "new": false,
            "name": "Philosophy Club",
            "type": "Humanities",
            "tier": "Special Interest",
            "desc": "Gunn Philosophy Club is a place to cultivate your critical thinking and discussion skills through analysis of philosophical ideas. We will be exploring broad, popular questions such as “Is reality objective?” or “What is consciousness?” as well as exploring the intricacies of niche philosophical concepts such as absurdism and emotivism. We also aim to focus on the applicability of philosophy, and explore its overlap with mathematics, linguistics, biology, and more. No prior experience is necessary, and all are welcome!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-101",
            "prez": "Sami Rahim",
            "advisor": "Jordan Wells",
            "email": "jwells@pausd.org"
        },
        "46000": {
            "new": false,
            "name": "Science Olympiad",
            "type": "Competition (only for Clubs)",
            "tier": "Financial",
            "desc": "Science Olympiad is an annual science competition with tournaments at the Regional, State, and National levels. Science Olympiad Club members represent Gunn at this competition each year, competing in events that cover a wide variety of topics including biology, chemistry, physics, and engineering. Besides preparing for the Science Olympiad tournament, members become a tight-knit team through fun club activities, group study sessions, and competing together at invitational tournaments. Gunn Science Olympiad is an amazing opportunity for students who are passionate about STEM and wish to take their skills to competitions while also having fun with friends and like-minded individuals :)",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-5",
            "prez": "Nathaniel Johnson",
            "advisor": "Ning Xu",
            "email": "nxu@pausd.org"
        },
        "46246": {
            "new": false,
            "name": "Women In STEM",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "In Silicon Valley, jobs in science, technology, engineering, and math are very common. And it can be especially hard for women to be heard in such a male-dominated industry. We want to support women and those who aim to enter STEM fields and also encourage more to join. We will have lessons and learn from strong women currently in the field, as well as women who are important to its history. We will have experiments and fun activities relating to STEM that hopefully inspire people to become a part of the STEM field.",
            "day": "Tuesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "C-2",
            "prez": "Emily Podulka",
            "advisor": "Warren Collier",
            "email": "wcollier@pausd.org"
        },
        "46388": {
            "new": true,
            "name": "Maker Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "____ club will help you learn how to build almost any project you can dream of! We will teach you how to design your own PCBs, design mechanisms and housings, and how to optimize your project for manufacturing. At the end of the year you will be able to use all your newly acquired engineering skills to bring one of your ideas to life!",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-210",
            "prez": "Aiden Farr",
            "advisor": "Marcus Jamison",
            "email": "mjamison@pausd.org"
        },
        "46587": {
            "new": true,
            "name": "Middle Eastern Students Association",
            "type": "Culture, Religion, and Language",
            "tier": "Special Interest",
            "desc": "The Middle Eastern Students Association is a club that aims to celebrate the diverse cultures, traditions, histories, languages, and experiences of the Middle East while bringing students together and creating a sense of community. Throughout the year, we plan to have fun presentations, activities, and food teaching other's about Middle Eastern culture. Overall, our goal is to create a fun, inclusive, and respectful environment where students can celebrate their heritage, learn about different cultures, and build friendships.",
            "day": "Tuesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "N-104 (paronable room)",
            "prez": "Jessica Jacobson",
            "advisor": "Marjorie Paronable",
            "email": "mparonable@pausd.org",
            "coadvisor": "N/A",
            "coemail": ""
        },
        "47527": {
            "new": false,
            "name": "Audio Arts Collective",
            "type": "Music and Performing Arts",
            "tier": "Special Interest",
            "desc": "We'll host open mics, jam sessions, music presentations, performances and more! If you play music or enjoy music, come hang out!!",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "L-7",
            "prez": "Gabriel A Lopez",
            "advisor": "Edward Corpuz",
            "email": "ecorpuz@pausd.org"
        },
        "47595": {
            "new": false,
            "name": "Clothing Club",
            "type": "Discussion",
            "tier": "Financial",
            "desc": "Clothing Club explores fashion, clothing, and style throughout history. Members will learn about, trends, designers, brands, and how clothing reflects society. Through discussions, students can discover fashion’s history while expressing their own personal style and learning something new.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "S-121",
            "prez": "William Jia",
            "advisor": "Susie Martone",
            "email": "smartone@pausd.org"
        },
        "48273": {
            "new": true,
            "name": "Pediatric Medicine Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Pediatric Medicine club plans to spread awareness of diseases and conditions that children deal with by educating our members about the specific causes of these medical disabilities, and how they can be prevented and/or treated. We also plan to fundraise for children's medical centers and those actively inhabiting them.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-103",
            "prez": "Mabel Johnson",
            "advisor": "Miranda Long",
            "email": "mlong@pausd.org"
        },
        "50893": {
            "new": false,
            "name": "AI In Business Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Discover how AI is transforming the business world in the AI and Business Club. Members will explore how companies use AI to solve problems and create opportunities, discuss the future of AI in industries, and engage in hands-on activities like brainstorming business ideas, learning how to create custom GPT's, and learning prompt engineering. Guest speakers from AI and business fields will inspire and share insights, fostering creativity and critical thinking.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-215 Lab",
            "prez": "Maitreyee Sen",
            "advisor": "Khoa Dao",
            "email": "kdao@pausd.org"
        },
        "51378": {
            "new": false,
            "name": "Mock Trial",
            "type": "Discussion",
            "tier": "Special Interest",
            "desc": "Mock Trial explores the American legal system, in which students can take the roles as attorneys and witnesses, analyze fictional cases, and practice public speaking / debate. No prior experience or large time commitment is required!",
            "day": "Thursday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "N-205",
            "prez": "Peter Fannion",
            "advisor": "Misha Hlasek",
            "email": "mhlasek@pausd.org"
        },
        "52314": {
            "new": false,
            "name": "Girls Tech Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Our mission is to create a community for girls and non-binary students to explore and pursue technology, engineering, and computer science. This involves spreading opportunities to club members, group activities, guest speakers, company tours, coding, and more. Anyone interested in tech, hanging out with friends, and having fun should join!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-115",
            "prez": "McKenna Chang",
            "advisor": "Takeshi Kaneko",
            "email": "tkaneko@pausd.org"
        },
        "53263": {
            "new": false,
            "name": "Card Game Club",
            "type": "Recreation",
            "tier": "Special Interest",
            "desc": "Come play cool card games with others. We meet during lunch and play traditional 52 playing card games. We play games like poker, up and down, and more. If you like playing strategic card game you can suggest new games for us to play.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "M-3",
            "prez": "Yehonatan Magen",
            "advisor": "Victoria Buck",
            "email": "vbuck@pausd.org"
        },
        "54749": {
            "new": false,
            "name": "Tea Club",
            "type": "Recreation",
            "tier": "Financial",
            "desc": "Tea Club is a place to relax and have a tea party in the middle of a stressful school day. We’ll experience the cultural aspects of serving and drinking tea, including tea biscuits and other tea snacks. Each month, we will focus on a different cultural tea-related theme, and every meeting will include teas and presentations related to the theme.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "L-8",
            "prez": "Adi Sharon",
            "advisor": "Tomas Grim",
            "email": "tgrim@pausd.org"
        },
        "55207": {
            "new": false,
            "name": "412 Christian Club",
            "type": "Culture, Religion, and Language",
            "tier": "Special Interest",
            "desc": "Our club will seek to bring hope, show God's love, share encouraging and inspiring scripture, messages, testimonies, and seminars. We'd like to teach and share with Christians what it means to follow Christ. We'd like to also show the larger student body love and encourage them to have hope and happiness in greater things.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "F-6",
            "prez": "Erik Lo",
            "advisor": "Patricia Holmes",
            "email": "pholmes@pausd.org"
        },
        "55803": {
            "new": false,
            "name": "Tetris Club",
            "type": "Recreation",
            "tier": "Special Interest",
            "desc": "Description: The Tetris Club welcomes everyone, from complete beginners to seasoned players, to enjoy Tetris and take a break from the hectic school day. Come play in a fun and supportive environment where you can compete in weekly sessions, learn new strategies and techniques, participate in bi-yearly tournaments, and more!",
            "day": "Thursday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "J-3",
            "prez": "Jaeyoon Kim",
            "advisor": "Micah Wynn",
            "email": "pmedeiros@pausd.org"
        },
        "56851": {
            "new": false,
            "name": "Helios Magazine",
            "type": "Visual Arts and Media",
            "tier": "Special Interest",
            "desc": "The Helios Magazine is a club open to all Gunn students who are interested in contributing to a professional and meaningful publication on campus, whether through art, design, or writing. We will work on distributing an entertaining, interesting, and thought-provoking magazine online every quarter, while teaching members the importance of ethical journalism and creative, professional writing. All welcome!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-106",
            "prez": "Vaani Saxena",
            "advisor": "Justin Brown",
            "email": "jdbrown@pausd.org"
        },
        "59332": {
            "new": false,
            "name": "Muslim Students Association",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "Our club is designed to be a space for Muslim students and allies to learn about the religion and just hang out. We aim to continue building a stronger community at Gunn, where everyone is welcome, regardless if they're Muslim or not. During our weekly meetings, we have presentations about Islam, famous Muslim figures, current events, and more. We also have games related to the content, including kahoots and pictionary. In addition, we have food at our meetings almost every week, and we host potlucks for special occasions such as Eid or the end of the semester!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "M-1",
            "prez": "Inaaya Ahmed",
            "advisor": "Marie Durquet",
            "email": "mdurquet@pausd.org"
        },
        "61193": {
            "new": true,
            "name": "Scene Workshop",
            "type": "Music and Performing Arts",
            "tier": "Special Interest",
            "desc": "In Scene Workshop, we will watch and read scenes from different live theatre productions, perform and workshop scenes with partners, and gain acting experience through exploring different approaches to a scene.",
            "day": "Tuesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "S-121",
            "prez": "Jiaqi (Tiger) Chu",
            "advisor": "Susie Martone",
            "email": "smartone@pausd.org"
        },
        "61216": {
            "new": false,
            "name": "Quiz Bowl",
            "type": "Competition (only for Financial Clubs)",
            "tier": "Financial",
            "desc": "Our club is centered around the academic competition Quiz Bowl, and accordingly we  field a Quiz Bowl team that competes in regional and national competitions. Quiz Bowl is a buzzer based competition where two teams compete against each other to answer academic questions. Any topic or field, from history to pop culture, can be the focus of a quiz bowl question. Besides the game of Quiz Bowl, we will also be doing many other trivia games, such as Jeopardy.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-2",
            "prez": "Ayan Kancherla",
            "advisor": "Christopher Johnson",
            "email": "cjohnson@pausd.org"
        },
        "63090": {
            "new": false,
            "name": "Classics Club",
            "type": "Culture, Religion, and Language",
            "tier": "Special Interest",
            "desc": "Our aim is to study global culture - not just Greco-Roman as is so often the convention in classical study - from Homeric Classical Antiquity through the end of the Middle Ages, primarily through a lens of literature and myth but also branching out to arts and culture. In addition to the Greece and Rome of Classical Antiquity we will also be studying European Christendom, Eastern, near-Eastern (pre- and post-Islamic), Celtic and Germanic societies. We are not experts, and the aim of the club is to teach everyone involved!",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-101",
            "prez": "Ayan Kancherla",
            "advisor": "Jordan Wells",
            "email": "jwells@pausd.org"
        },
        "63683": {
            "new": true,
            "name": "Pharmaceutical Science Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "This club aims to teach students about pharmaceutical science and careers in the field through interactive meetings and presentations. Students will learn topics and applications of pharmaceutical science in related fields such as cancer therapeutics, neuroscience drugs, pharmacology, etc. We’ll strive to have interactive lab experiments, guest speakers and potentially a field trip as well as a community impact project. Through this club, students will get the opportunity to have impact and learn about highly relevant topics in pharmaceutical sciences and related fields. We will also have snacks at every meeting and ensure that this is a fun and collaborative space.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-4",
            "prez": "Abhi Singh",
            "advisor": "Mica Perez",
            "email": "mperez@pausd.org"
        },
        "64251": {
            "new": true,
            "name": "Spikeball Club",
            "type": "Sports",
            "tier": "Special Interest",
            "desc": "The purpose of this club is to provide students with an opportunity to play and enjoy Spikeball in a welcoming and inclusive environment. Students of all experience levels are encouraged to come. Beginners will have the opportunity to learn the fundamentals, while more experienced players can play at a higher level with others at a similar skill level, further developing their abilities.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "G-4",
            "prez": "Daniel Wang",
            "advisor": "Gabriela Garger",
            "email": "ggarger@pausd.org"
        },
        "65520": {
            "new": true,
            "name": "Competition Engineering club",
            "type": "Competition (only for Financial Clubs)",
            "tier": "Financial",
            "desc": "We provide a space for people participating in engineering competitions to learn problem-solving strategies and a place to centralize information on upcoming competitions.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-3",
            "prez": "Kai Xin",
            "advisor": "Ben Beresford",
            "email": "bberesford@pausd.org"
        },
        "66282": {
            "new": false,
            "name": "TEDxGunnHighSchool",
            "type": "Discussion",
            "tier": "Financial",
            "desc": "TEDxGunnHighSchool is a student team dedicated to sharing our community's unique ideas with the world. Our main mission is producing Gunn’s annual TEDx conference. We curate speakers, coordinate performers, and produce final videos for the official TEDx YouTube channel. Join us to help bring this year's conference to life!",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-8",
            "prez": "Esther Li",
            "advisor": "Daljeet Gill",
            "email": "dgill@pausd.org"
        },
        "66931": {
            "new": true,
            "name": "Indie Game Club",
            "type": "Visual Arts and Media",
            "tier": "Special Interest",
            "desc": "Meet new people and try new games at Indie Game Club! We have weekly activities and competitions related to these games, as well as collaborations to make levels. Join a welcoming community open to people at all skill levels.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "G-1",
            "prez": "Sumayya Khan",
            "advisor": "David Bisbee",
            "email": "dbisbee@pausd.org"
        },
        "67628": {
            "new": false,
            "name": "Dance Club",
            "type": "Music and Performing Arts",
            "tier": "Special Interest",
            "desc": "Dance Club is a welcoming space for all students to come together and connect through the joy of dance. Dance Club is open to everyone, regardless of experience, and focuses on building a sense of community while helping students stay active and energized. We vote on dances to learn, and students have the option of filming them to post on our club instagram!",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-7",
            "prez": "Vivian Wang",
            "advisor": "Elana Zizmor",
            "email": "ezizmor@pausd.org"
        },
        "69532": {
            "new": false,
            "name": "Key Club",
            "type": "Service and Wellbeing",
            "tier": "Special Interest",
            "desc": "Key Club is a service-forward club that exists at many schools all over the nation. At each meeting, we complete a service activity (you can earn volunteer hours!). We also plan and discuss outside service opportunities. We are connected with other Key Clubs at schools in the area, and there are monthly connection events with them.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-205",
            "prez": "Yaya Li",
            "advisor": "Misha Hlasek",
            "email": "mhlasek@pausd.org"
        },
        "69949": {
            "new": false,
            "name": "Taiwanese Student Association",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "At the Henry M. Gunn High School Taiwanese Student Association (TSA) club, our goal is to have every member develop a greater appreciation for Taiwanese culture through light lectures, games, food, fundraisers, art, and more. We want to spread Taiwanese culture to everyone, while letting members have tons of fun throughout the journey.",
            "day": "Tuesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "K-10",
            "prez": "Ashley Lee",
            "advisor": "Timothy Young",
            "email": "tyoung@pausd.org"
        },
        "70860": {
            "new": false,
            "name": "German Club",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "We play authentic German games, listen to German music, eat and make delicious German food, and engage in activities that parallel those typical in Germany.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "H-2",
            "prez": "Maksymilian Langner",
            "advisor": "Claudia Schroeppel",
            "email": "cschroeppel@pausd.org",
            "coadvisor": "T. Sophia Lo",
            "coemail": "tslo@pausd.org"
        },
        "71551": {
            "new": false,
            "name": "South Asian Student Association",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "Our club is a place for all people to gather and form a community, whilst learning more about the many diverse and beautiful cultures of South Asia. We have weekly activities, games, and also participate in local events throughout the year. Everyone is welcome, regardless of background; we hope to see you there!",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-3",
            "prez": "Inaaya Ahmed",
            "advisor": "Daljeet Gill",
            "email": "dgill@pausd.org"
        },
        "71893": {
            "new": false,
            "name": "Dungeons and Dragons Club",
            "type": "Recreation",
            "tier": "Financial",
            "desc": "Gunn Dungeons and Dragons Club is THE quintessential club to all things Dungeons and Dragons at Gunn. From complete beginners to veteran Dungeon Masters, this club accepts all! Organize D&D Campaigns and hang out with your friends; or, if you are a battle-hardened \"nerd,\" debate in heated interpretations of the game! Come join and play the most popular Table Top Roleplaying Game (TTRPG) of all time, and step into a world determined entirely by your imagination by joining Gunn D&D!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-15",
            "prez": "Evan Little",
            "advisor": "Briana Gonzalez",
            "email": "bgonzalez@pausd.org"
        },
        "73212": {
            "new": false,
            "name": "Math Circle",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Purpose & Impact: The purpose of the club is to expose students to math outside of the traditional high school classroom, with a focus on math competitions such as the AMC Series and Bay Area Math Olympiad. In addition to this, the club will inform members of math events not held at Gunn. By explaining various concepts typically not shared in a high school math class setting, we seek to promote an understanding beyond the traditional high school curriculum and spark an interest in math beyond high school.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-214",
            "prez": "Alex Tsagaan",
            "advisor": "Daniel Hahn",
            "email": "dhahn@pausd.org"
        },
        "73371": {
            "new": false,
            "name": "Jewish Student Union",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "JSU is a place where all students, Jewish and not, can learn about and celebrate Jewish culture. We have Chanukah parties, craft activities, and food at every meeting! The Gunn JSU is a branch of the larger Jewish Student Union, which is designed to bring together people to celebrate Jewish joy.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-1",
            "prez": "Leah Zeitzer",
            "advisor": "Ariane Tuomy",
            "email": "atuomy@pausd.org"
        },
        "76373": {
            "new": false,
            "name": "Weightlifting Club",
            "type": "Sports",
            "tier": "Special Interest",
            "desc": "Opportunity for students to use Gunn’s weight room facilities. Members have access to coaching from officers and club advisor, as well as a chance to take a break from academics and enjoy working out with friends.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "After School",
            "room": "Weight Room",
            "prez": "Gabriel Espinoza",
            "advisor": "Katherine Ja",
            "email": "kja@pausd.org"
        },
        "77522": {
            "new": false,
            "name": "Anatomy and Physiology",
            "type": "STEM",
            "tier": "Financial",
            "desc": "The purpose of the Gunn Anatomy and Physiology Club is to teach students the anatomy and physiology of different specimens while also providing students the opportunity to take part in hands-on dissections. This club hopes to inform more students about the amazing world of anatomy and physiology. Every week, this club will be either teaching or dissecting a specific specimen in order to fully understand the specimen’s anatomy and physiology. This will allow students to take time in understanding the science behind each animal and expanding their science knowledge. This club gives the school a chance to be exposed to dissections and various other content related to the human physiology and systems if not given the chance to take the Gunn Anatomy Class. As mentioned earlier, this club will be actively participating in dissections during club hours. The act of doing the dissection after learning about the anatomy and physiology of the specimen allows students to further strengthen their knowledge in the field.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-4",
            "prez": "Sharvi Dhamdhere",
            "advisor": "Micah Wynn",
            "email": "mwynn@pausd.org"
        },
        "77894": {
            "new": false,
            "name": "Red Cross Club",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "Volunteer with us to gain service hours during club meetings! We will act as an extension of the local Red Cross chapter, doing mission-related services (such as raising awareness online for disaster preparedness), organize and participate in a variety of local volunteering opportunities, and diving deeper into more information about what Red Cross is and what they do. Club perks include access to the Red Cross network, and being officially registered as a Red Cross volunteer!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-3",
            "prez": "Sophie Dulani",
            "advisor": "Mark Brassey",
            "email": "mbrassey@pausd.org"
        },
        "79704": {
            "new": true,
            "name": "Cryptic Crossword Club",
            "type": "Humanities",
            "tier": "Special Interest",
            "desc": "Learn how to solve (and possibly write) cryptic crosswords! They're like normal crosswords, but the clues are completely different; half is a normal definition and half is wordplay that gets you to the same answer.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-2",
            "prez": "Colin Tivol",
            "advisor": "Heather Mellows",
            "email": "hmellows@pausd.org",
            "coadvisor": "Jena Lee",
            "coemail": "jlee@pausd.org"
        },
        "81780": {
            "new": false,
            "name": "The Chariot",
            "type": "Humanities",
            "tier": "Special Interest",
            "desc": "The Gunn Chariot is a political and cultural student-led magazine. We meet once a week on Mondays in room N-106. We distribute physical glossy copies twice a year and online throughout the duration of the school year. Our mission is to provide a creative and inclusive space for writers to have the flexibility of writing topics they are passionate about. We cover a wide range of topics, from local issues to national coverage. The Chariot is a pillar of the Gunn Community, providing opportunities for aspiring artists and writers, producing quality for over 25 years. So whether you would like to try designing graphics, writing a story, or even just looking for a community, we would love to have you.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-106",
            "prez": "Mayher Dulani",
            "advisor": "Justin Brown",
            "email": "jdbrown@pausd.org"
        },
        "82626": {
            "new": false,
            "name": "Human Cognition and AI",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Our Human Cognition and AI Club will learn how basic AI processes work and how they can advance by beginning to make decisions like humans. We will study ideas from cognitive science, neuroscience, computer science, and psychology. Then, through our discussions, projects, and activities, we can further develop our understanding of human cognition in AI. Through online research and experimentation, students will learn both a deeper understanding in AI and also in human cognition.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "G-4",
            "prez": "Stephen Sheng",
            "advisor": "Gabriela Garger",
            "email": "ggarger@pausd.org"
        },
        "82873": {
            "new": false,
            "name": "Cybersecurity Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Cybersecurity Club is the place to go for information and tips on hacking! We cover weekly news on data breaches, ransomware attacks, etc. and teach you how to ethically learn as well. There will also be content on defense and protecting yourself from various attacks. We focus on command line (bash) as well as exploit scripting. Our primary focus is on competing in CTF (Capture the Flag) competitions and building a white hat programming community.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-212",
            "prez": "Diya Bhagat",
            "advisor": "David Deggeller",
            "email": "ddeggeller@pausd.org"
        },
        "82975": {
            "new": true,
            "name": "Game Development and Playtesting Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "We will be teaching topics on game design, development, programming, and playtesting during our meetings. Our club is both for students who want to learn to build games and those who simply enjoy playing them and want a chance to playtest some fun original games!",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "G-1",
            "prez": "Mason Lee",
            "advisor": "David Bisbee",
            "email": "dbisbee@pausd.org"
        },
        "83636": {
            "new": false,
            "name": "Students Against Cancer",
            "type": "STEM",
            "tier": "Financial",
            "desc": "Students Against Cancer is a club dedicated to raising awareness about cancer, its causes, and prevention. During lunch meetings, we’ll explore how cancer develops, discuss common risk factors, and share healthy lifestyle choices. Members will create monthly awareness flyers aligned with national cancer awareness months, organize fundraisers to make and donate cancer care kits, and may also participate in outreach to elementary schools and community centers to promote healthy habits and cancer prevention. Together, we aim to empower our community through knowledge, awareness, and action.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-15",
            "prez": "Sharvi Dhamdhere",
            "advisor": "Briana Gonzalez",
            "email": "bgonzalez@pausd.org"
        },
        "84019": {
            "new": true,
            "name": "Second Movement: Music for Seniors",
            "type": "Music and Performing Arts",
            "tier": "Financial",
            "desc": "Second Movement is a student music group that prepares short concert programs and performs them for older adults at senior residences around Palo Alto. We meet weekly at lunch to choose repertoire, sort out who is playing what, run through pieces in small groups, and get programs performance-ready. Members work on their own parts on their own time, the way musicians always have. Members play whatever they already play: strings, piano, winds, guitar, voice. We perform a few times each semester, and no member is required to play at every performance. Our aim is to give Gunn musicians a genuine audience and to bring live music to neighbors who rarely get to hear any. No audition, no experience level required.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-107",
            "prez": "Jacob Zhao",
            "advisor": "Katherine Janson",
            "email": "kjanson@pausd.org",
            "coadvisor": "Florina Limburg",
            "coemail": "flimburg@pausd.org"
        },
        "84338": {
            "new": false,
            "name": "AI Ethics Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "Our club provides a space for students to engage critically with the questions AI raises for society. Activities include discussing research papers, debating issues like algorithmic bias, privacy, and AI governance, and connecting ideas to real-world applications through projects, guest talks, and collaborative discussions. No prior experience with AI is required—just an open mind and a willingness to think critically.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "G-4",
            "prez": "Anika Datta",
            "advisor": "Gabriela Garger",
            "email": "ggarger@pausd.org"
        },
        "84469": {
            "new": false,
            "name": "French Club",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "French Club helps current French students and any other students interested in French explore French culture through presentations, games, and other miscellaneous activities. The club highlights French holidays for the most part. Extra activities include participating in Oktoberfest and National French Week. The club also hosts French Honor Society.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "H-1",
            "prez": "Alvin Han",
            "advisor": "Madame Angeles",
            "email": "jangeles@pausd.org"
        },
        "85555": {
            "new": true,
            "name": "Astronomy Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "The Gunn Astronomy Club is dedicated to helping students learn about and appreciate the wonders of astronomy and astrophysics. We discuss the field's biggest questions, keep up to date on discoveries and events, and participate in our own research projects using real telescope data online. We also introduce members to competitions like the USA Astronomy and Astrophysics Olympiad and host study sessions to help them prepare. No matter your level of experience, everyone is welcome!",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-2",
            "prez": "Brian Liu",
            "advisor": "Jena Lee",
            "email": "jlee@pausd.org"
        },
        "86291": {
            "new": false,
            "name": "Unhoused Action Club (formerly known as Homeless Action Club)",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "We organize socks, hygiene kits, and coats drives for Hope's Corner's clients. We also prepare and serve Sunday Supper at our Teacher Advisor's church once a month.",
            "day": "Friday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "Room G-3",
            "prez": "Trinity Smith",
            "advisor": "Kirsten Tasker",
            "email": "ktasker@pausd.org"
        },
        "86594": {
            "new": false,
            "name": "Marine Biology Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "Marine Biology Club is a community for all people who love the ocean and have a passion for marine ecosystems! We cover a variety of topics, such as marine mammals, corals, jellyfish, echinoderms, and more. We also strive to bring awareness to topics like ocean acidification, pollution, overfishing, and other issues that pose a threat to marine life. We hold meetings every Wednesday in K4, and our typical meetings usually include a presentation, a fun activity, and snacks. Sea you there!",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-4",
            "prez": "Mina Yanagihara",
            "advisor": "Neeti Schworetzky",
            "email": "nschworetzky@pausd.org"
        },
        "87856": {
            "new": true,
            "name": "Black Student Union",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "We're a culture club looking to affirm identity, build community, and bring awareness to the student body at large",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-15",
            "prez": "Sophia Chakos-Mitchell",
            "advisor": "Dethrick Slocum",
            "email": "dslocum@pausd.org",
            "coadvisor": "Latrice Bennett",
            "coemail": "lbennett@pausd.org"
        },
        "88519": {
            "new": true,
            "name": "Computational Biology Club",
            "type": "STEM",
            "tier": "Financial",
            "desc": "The Gunn Computational Biology Club teaches students to use research-grade databases and data-analysis tools, critically evaluate scientific papers, conduct original computational research WITHOUT a wet lab, and write their own research papers. Affiliated with miRcore, a nonprofit based at the University of Michigan–Ann Arbor, our club also offers competitions and guest talks from leading scientists.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-3",
            "prez": "Ethan Lo",
            "advisor": "Amy Bradshaw",
            "email": "abradshaw@pausd.org"
        },
        "89570": {
            "new": false,
            "name": "Competitive Programming Club",
            "type": "Competition (only for Clubs)",
            "tier": "Financial",
            "desc": "Competitive programming club is a community for coders of all levels! During meetings, we learn about USACO-style algorithms, have fun contests, and share lots of food and knowledge. Members also help organize the annual Bay Area Programming Contest (BAPC), which includes programming, merch, food/boba, and prizes!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-214",
            "prez": "Simren Arora",
            "advisor": "Daniel Hahn",
            "email": "dhahn@pausd.org"
        },
        "90242": {
            "new": false,
            "name": "Women in Politics",
            "type": "Discussion",
            "tier": "Financial",
            "desc": "Gunn Women in Politics aims to empower students to explore civic engagement and leadership. \"Politics\" encompasses a wide range of topics that can often become confused with public relations drama and party rivalries. With an emphasis on women in politics, we will engage students in local, state, federal, and even international politics through discussions, workshops, campaign simulations, and speaker events.  Women in Politics offers a wonderful opportunity for individuals—especially female students—to engage in meaningful dialogue, advocacy training, gain practical experience, and stay informed about various political matters. If you want to build valuable connections in a collaborative, community-focused environment, our club is the perfect place for you!",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-8",
            "prez": "Phoebe Selker",
            "advisor": "Tara Firenzi",
            "email": "tfirenzi@pausd.org"
        },
        "90777": {
            "new": false,
            "name": "UNICEF",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "In the club, UNICEF, we aim to learn, inspire, and take action to create a more equitable world for every child. We will explore UNICEF’s mission and learn about the challenges children face around the world, including issues involving children’s rights, education, healthcare, and access to basic resources. Our primary objective is to raise awareness about these issues and encourage students to become active members of their communities through educational campaigns, advocacy, community outreach, and fundraising.",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "C-6",
            "prez": "Bella Liu",
            "advisor": "Alexis Letner Lee",
            "email": "aletner@pausd.org"
        },
        "92919": {
            "new": false,
            "name": "Checkmate",
            "type": "Recreation",
            "tier": "Special Interest",
            "desc": "Checkmate is a place for all students irrespective of skill level, where people can come together over the game of chess, whether they want to play with others or just learn the game. We aim to build a fun and engaging environment where students can learn, practice, and improve. We plan to meet every other week.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "H-4",
            "prez": "Riva Malhotra (Interim)",
            "advisor": "Yanan Vrudny",
            "email": "yvrudny@pausd.org"
        },
        "93631": {
            "new": false,
            "name": "Spanish Club",
            "type": "Culture, Religion, and Language",
            "tier": "Financial",
            "desc": "Join Gunn Spanish Club to explore the rich Spanish-speaking culture through games, food, and arts & crafts! NO Spanish speaking knowledge is required! Spanish club allows you to build a close community at Gunn with people from all grades, and members of Spanish club who are sophomores, juniors, or seniors have the opportunity to become inducted to the Spanish National Honors Society. Join us on Thursdays at lunch in room H-5.",
            "day": "Thursday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "H-5",
            "prez": "Melody Na",
            "advisor": "Teresa Nino Oliva",
            "email": "tninooliva@pausd.org"
        },
        "94453": {
            "new": false,
            "name": "Pandora's Box Creative Magazine",
            "type": "Visual Arts and Media",
            "tier": "Financial",
            "desc": "Pandora’s Box is a student-led creative magazine that has been in production for over 20 years. We publish magazines showcasing writing, art, and photography from Gunn students to give them recognition for their talents. Our members come together to meet about design choices for the magazine to hand them out during the last month of the semester.",
            "day": "Friday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "N-114",
            "prez": "Nicole Mok",
            "advisor": "Paul Dunlap",
            "email": "pdunlap@pausd.org"
        },
        "96416": {
            "new": false,
            "name": "Organic Garden Club",
            "type": "Recreation",
            "tier": "Financial",
            "desc": "Our club plants, maintains, and harvests a wide variety of produce in the Gunn garden. We aim to help students reconnect with nature hands-on and learn how growing food actually works, all while taking care of a valuable green space on campus.",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "the Gunn garden! (near the K building)",
            "prez": "Mirabelle Upstill",
            "advisor": "Cindy Peters",
            "email": "cpeters@pausd.org"
        },
        "98344": {
            "new": false,
            "name": "Green Team",
            "type": "Service and Wellbeing",
            "tier": "Financial",
            "desc": "Learn about the environment and climate activism through fun activities, presentations, guest speakers, and more. We also provide many local volunteer opportunities such as tree plantings and beach cleanups!",
            "day": "Tuesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "K-3",
            "prez": "Mina Van Roy",
            "advisor": "Mark Brassey",
            "email": "mbrassey@pausd.org"
        },
        "98498": {
            "new": false,
            "name": "Music Composition",
            "type": "Music and Performing Arts",
            "tier": "Special Interest",
            "desc": "We create musical pieces alongside a website called palo alto youth composers that helps network composers in the bay area. Our goal is to teach rising freshmen and sophmores how to compose, as well as nurture their creativity. We sometimes partner with the orchestra, with them sight reading the pieces that we write, and it's generally a very fun, and insightful experience.",
            "day": "Friday",
            "freq": "More than once a week",
            "time": "Lunch",
            "room": "L-6",
            "prez": "Ada Chen",
            "advisor": "Ed Corpuz",
            "email": "ecorpuz@pausd.org"
        },
        "99480": {
            "new": false,
            "name": "Juggling Club",
            "type": "Recreation",
            "tier": "Financial",
            "desc": "To assist fellow jugglers and to spread the joy of juggling to the Gunn community.",
            "day": "Wednesday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "Senior Quad, H-3",
            "prez": "Konstantin (Kostya) Antonov",
            "advisor": "Matt Hall",
            "email": "mhall@pausd.org"
        },
        "99785": {
            "new": false,
            "name": "A.C.S Chemistry Club",
            "type": "STEM",
            "tier": "Special Interest",
            "desc": "The purpose of the ACS ChemClub is to create a community of Gunn students interested in chemistry to be able to come together and conduct experiments or discuss new concepts. For monthly goals, the club aims to complete a minimum of 1 experiment per month including going over safety procedures prior to the lab and a lab analysis thereafter. Another monthly goal is to have 1 informative session per month sharing career, training, and college opportunities information. Yearly goals include hosting 2 or more chemistry olympiad study sessions, encouraging a minimum of a third of our club to participate in the Chemistry Olympiad, and inviting 2 role models in the professional chemistry community to come speak during a club meeting",
            "day": "Monday",
            "freq": "Once a week",
            "time": "Lunch",
            "room": "J-7",
            "prez": "Daniel Luo",
            "advisor": "Elana Zizmor",
            "email": "ezizmor@pausd.org"
        },
        "99986": {
            "new": false,
            "name": "Lifestyle Medicine",
            "type": "Service and Wellbeing",
            "tier": "Special Interest",
            "desc": "The Lifestyle Medicine Club aims to improve student wellbeing by focusing on the 7 pillars: Physical Activity, Nutrition, Sleep, Stress Management, Social Connection, Gratitude, and Cognitive Enhancement. Our goal is to translate these clinical pillars into actionable habits that help Gunn students thrive academically and personally while building a culture of long-term health.",
            "day": "Tuesday",
            "freq": "Every Other Week",
            "time": "Lunch",
            "room": "C-3",
            "prez": "Isaac Fredericson",
            "advisor": "Tara Firenzi",
            "email": "tfirenzi@pausd.org",
            "coadvisor": "Benjamin Beresford",
            "coemail": "bberesford@pausd.org"
        }
    }
}
export default clubs;
